const paymentStatusEnum = Object.freeze({
    PAID: 5,
    UNPAID: 10
});
export default paymentStatusEnum;
